<script lang="ts">
  import type { Filter } from '../global'

  export let selected: string
  export let label: string
  export let options: Filter.Option[]
</script>

<div class="flex items-center gap-2">
  <label for="order">{label}</label>
  <select
    id="order"
    class="select grow !text-sm !leading-none sm:grow-0"
    name="order"
    bind:value={selected}
    on:change
  >
    {#each options as { value, text }}
      <option {value}>{text}</option>
    {/each}
  </select>
</div>
